export const URL_PATTERN =
  /^[a-zA-Z:/]+[a-zA-Z0-9@:%._+~#=,]{1,256}\b([-a-zA-Z0-9()@:%_\+.~#?&//={},]*)$/i;
export const SUBID_PATTERN = /^[-\d,]*$/i;
export const ANDROID_VERSION_PATTERN = /^[\d,.\s]*$/i;
export const appTimeRegExp = (): RegExp =>
  new RegExp('^[0-9]{2}:[0-9]{2}$', 'i');
